import { forwardRef } from "react";
import classNames from "classnames";

const MenuListDropdown = forwardRef(function MenuListDropdown({ show, className, children }, ref) {
  return (
    <div
      ref={ref}
      className={classNames("menu-list-dropdown", show && "show", className)}
    >
      {children}
    </div>
  );
});

export default MenuListDropdown;
